
import { Component, Vue, Prop } from 'vue-property-decorator';
import PageBase from "../PageBase.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";
import { togglePages } from '@/components/utils/TogglePages';

import * as _ from 'underscore';
import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import LegalAssistanceFaq from "@/components/utils/LegalAssistanceFaq.vue";
import Tooltip from "@/components/survey/Tooltip.vue";
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

@Component({
    components:{
        PageBase,
        Tooltip,
        LegalAssistanceFaq
    }
})
export default class PpmQuestionnaire extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    @applicationState.Action
    public UpdatePathwayCompleted!: (changedpathway) => void
    
    selectedPriorityParentingMatter = [];

    showLegalAssistance = false

    currentStep = 0;
    currentPage = 0;

    allPages = []; 

    mounted(){
        this.allPages = _.range(this.stPgNo.PPM.PriorityParentingMatterOrder, Object.keys(this.stPgNo.PPM).length-1) 
        this.reloadPageInformation();
    }

    public reloadPageInformation() {

        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        
        if (this.step.result?.ppmQuestionnaireSurvey) {
            this.selectedPriorityParentingMatter = this.step.result.ppmQuestionnaireSurvey.data;
        }
        
        const progress = this.selectedPriorityParentingMatter.length==0? 50 : 100;        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }


    public onChange(selectedPriorityParentingMatter) {

        this.UpdatePathwayCompleted({pathway:"priorityParenting", isCompleted:false});
        togglePages([this.stPgNo.PPM.PreviewFormsPPM], false, this.currentStep);
        
        if(this.checkErrorOnPages())        
            this.setSteps(selectedPriorityParentingMatter);
        else{ 
            this.selectedPriorityParentingMatter = [];             
        }
        Vue.filter('surveyChanged')('priorityParenting')        
    }

    public setSteps(selectedPriorityParentingMatter) {

        const p = this.stPgNo.PPM
        if (selectedPriorityParentingMatter) {

            togglePages(this.allPages, false, this.currentStep); 
            const progress = this.selectedPriorityParentingMatter.length==0? 50 : 100;
            Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);

            if (selectedPriorityParentingMatter.length > 0){

                togglePages([p.PriorityParentingMatterOrder], true, this.currentStep);                
                
                if(this.$store.state.Application.steps[this.currentStep].pages[p.PriorityParentingMatterOrder].progress==100)
                    Vue.filter('setSurveyProgress')(null, this.currentStep, p.PriorityParentingMatterOrder, 50, false);
                
                if(this.$store.state.Application.steps[this.currentStep].pages[p.PpmChildrenInfo].progress==100)
                    Vue.filter('setSurveyProgress')(null, this.currentStep, p.PpmChildrenInfo, 50, false);

                if(this.$store.state.Application.steps[this.currentStep].pages[p.PpmBackground].progress==100)
                    Vue.filter('setSurveyProgress')(null, this.currentStep, p.PpmBackground, 50, false);

                if(this.$store.state.Application.steps[this.currentStep].pages[p.AboutPriorityParentingMatterOrder].progress==100)
                    Vue.filter('setSurveyProgress')(null, this.currentStep, p.AboutPriorityParentingMatterOrder, 50, false);

                if(this.$store.state.Application.steps[this.currentStep].pages[p.PpmIndigenousAncestryOfChild].progress==100)
                    Vue.filter('setSurveyProgress')(null, this.currentStep, p.PpmIndigenousAncestryOfChild, 50, false);

                if(this.$store.state.Application.steps[this.currentStep].pages[p.PpmAdditionalDocuments].progress==100)
                    Vue.filter('setSurveyProgress')(null, this.currentStep, p.PpmAdditionalDocuments, 50, false);

            
                Vue.filter('setSurveyProgress')(null, this.currentStep, p.ReviewYourAnswersPPM, 0, false);
                
            }   

        }
    } 

    public checkErrorOnPages(){

        const optionalLabels = ["Next Steps", "Review and Print", "Review and Save", "Review and Submit"]
        for(const stepIndex of [this.stPgNo.COMMON._StepNo]){
            const step = this.$store.state.Application.steps[stepIndex]
            if(step.active){
                for(const page of step.pages){
                    if(page.active && page.progress!=100 && optionalLabels.indexOf(page.label) == -1){
                        togglePages(this.allPages, false, this.currentStep); 
                        this.$store.commit("Application/setCurrentStep", step.id);
                        this.$store.commit("Application/setCurrentStepPage", {currentStep: step.id, currentPage: page.key });                        
                        return false;
                    }
                }
            }            
        }
        return true;        
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();       
    }   

    public getSelectedPriorityParentingMatterNames(){
        let result = ''       
        for(const form of this.selectedPriorityParentingMatter){
            if(form=='medical')   result+='-Medical, dental or other health-related treatments for a child'+'\n';
            if(form=='passport')  result+='-Application for a passport, license or other thing for a child'+'\n';
            if(form=='travel')    result+='-Travel or participation in an activity for the child'+'\n';
            if(form=='locationChange')         result+='-Change in location of a child’s residence'+'\n';
            if(form=='preventRemoval')          result+='-Preventing the removal of a child'+'\n';
            if(form=='interjurisdictional')    result+='-Determining matters relating to interjurisdictional issues under section 74(2)(c) of the Family Law Act'+'\n';
            if(form=='wrongfulRemoval')         result+='-Wrongful removal of a child in BC'+'\n';
            if(form=='returnOfChild')          result+='-Preventing the removal of a child'+'\n';
            if(form=='childServices')          result+='-Parenting arrangements or guardianship of a child who has been removed or is at risk of being removed by the Director'+'\n';
        }
        return result;
    }
  
    beforeDestroy() {
        const progress = this.selectedPriorityParentingMatter.length==0? 50 : 100;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
        const questions = [{name:'PpmQuestionnaire',title:'I need help with the following priority parenting matter:',value:this.getSelectedPriorityParentingMatterNames()}]        
        this.UpdateStepResultData({step:this.step, data: {ppmQuestionnaireSurvey: {data: this.selectedPriorityParentingMatter, questions: questions, pageName:"Priority Parenting Matters Questionnaire", currentStep:this.currentStep, currentPage:this.currentPage}}});
    }
}
